/*
 * @Author: chenxing
 * @Date: 2021-04-01 11:23:00
 * @LastEditors: Yran
 * @LastEditTime: 2021-12-17 20:32:52
 */

import axios from '@/utils/axios';

const apiUrl = {
  saveWorkTime: '/sys/allotUserLaborHour/saveOrUpdateAllotUserLaborHour',
  getWorkTime: '/sys/allotUserLaborHour/list',
  getWorkWeekTime: '/sys/labor/hour/_get',
  addWorkWeekTime: '/sys/labor/hour/_save',
  getUserMessage: '/sys/user/info',
};

export function saveWorkTime(param = {}) {
  return axios.post(apiUrl.saveWorkTime, param);
}

export function getWorkTimeData(param = {}) {
  return axios.post(apiUrl.getWorkTime, param);
}
export function getWorkWeekTimeData(param = {}) {
  return axios.post(apiUrl.getWorkWeekTime, param);
}
export function addWorkWeekTimeData(param = {}) {
  return axios.post(apiUrl.addWorkWeekTime, param);
}
export function getUserMessageData(userId) {
  return axios.get(apiUrl.getUserMessage + `/${userId}`);
}
